import { useEffect, useRef, useState } from "react";
import { MAX_RATIO, MIN_PANEL } from "../../conts/constants.js";

// Dragging the border between the map and the side panel.
const usePanelResize = () => {
  const workspaceRef = useRef(null);
  const [panelWidth, setPanelWidth] = useState(null); // null = CSS default
  const [resizing, setResizing] = useState(false);
  const stopListening = useRef(null); // removes the window listeners

  // if the template unmounts mid-drag, remove the listeners
  useEffect(() => () => stopListening.current?.(), []);

  const startResize = (e) => {
    e.preventDefault();
    setResizing(true);

    const onMove = (ev) => {
      const rect = workspaceRef.current.getBoundingClientRect();
      const width = rect.right - ev.clientX;
      setPanelWidth(
        Math.round(Math.min(Math.max(width, MIN_PANEL), rect.width * MAX_RATIO)),
      );
    };
    const onUp = () => {
      setResizing(false);
      stopListening.current?.();
    };

    stopListening.current = () => {
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerup", onUp);
      stopListening.current = null;
    };
    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerup", onUp);
  };

  const resetPanelWidth = () => setPanelWidth(null);

  return { workspaceRef, panelWidth, resizing, startResize, resetPanelWidth };
};

export default usePanelResize;
